<script setup lang="ts">
import { Ref, ref, computed } from "vue";
import SpecialCaseSelectModal from "@/components/DailyReportUpdateModalParts/SpecialCaseSelectModal.vue";
import IgnoreLongTimelongContinuousWarning from "@/components/DailyReportUpdateModalParts/IgnoreLongTimelongContinuousWarning.vue";
import UnexpectedEventModals from "@/components/DailyReportUpdateModalParts/UnexpectedEventModals.vue";
import DeliveryPlan from "@/types/DeliveryPlan";
import { UNEXPECTED_EVENT_KEY, SPECIAL_EXTENSION_KEY } from "@/services/consts"

const emits = defineEmits(['update:modelValue', 'openModal'])

const props = defineProps<{
  modelValue:  boolean,
  deliveryPlan: DeliveryPlan
  createAuthority: boolean
  showFlash: (message: string, show: boolean, type: string, fadeout: boolean) => void
}>()

const unexpectedEventModalStatus: Ref<boolean> = ref(false)
const ignoreLongTimelongContinuousWarningModalStatus: Ref<boolean> = ref(false)

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function openModal(key: string) {
  modelValue.value = false
  if (key == SPECIAL_EXTENSION_KEY) {
    ignoreLongTimelongContinuousWarningModalStatus.value = true;
  }
  if (key == UNEXPECTED_EVENT_KEY) {
    unexpectedEventModalStatus.value = true;
  }
}
</script>
<template>
  <SpecialCaseSelectModal
    v-model="modelValue"
    @openModal="openModal"
  />
  <UnexpectedEventModals
    v-model="unexpectedEventModalStatus"
    :deliveryPlan="props.deliveryPlan"
    :createAuthority="props.createAuthority"
    :showFlash="props.showFlash"
  />
  <IgnoreLongTimelongContinuousWarning
    v-model="ignoreLongTimelongContinuousWarningModalStatus"
    :deliveryPlanId="props.deliveryPlan.delivery_plan_id"
    :createAuthority="props.createAuthority"
    :showFlash="props.showFlash"
  />
</template>
